import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmReportsCustomEditRoute: InvariantJiraRoute = {
	name: 'csm-reports-custom-edit',
	path: '/jira/customer-service-management/projects/:projectKey/reports/custom/:reportId/edit',
};
